import { bindActionCreators } from 'redux'
import { SelectCard } from '@piconetworks/cards'
import withInjection from '@piconetworks/with-injection'

import Internal from 'common/modules/internal'
import Payment from 'common/modules/payment'
import Loader from 'common/modules/loader'
import Wizard from 'common/modules/wizard'
import WizardRedux, { WizardLoading } from 'common/pkgs/WizardRedux'
import { paymentMethods } from 'common/modules/selectors'
import xFrame from 'common/xFrame'

const mapStateToProps = (state, props) => {
    const { router, history } = props

    const guestLoader = state.loader.guest
    const userLoader = state.loader.user
    const scopedLoader = userLoader || guestLoader

    const isVerified = Loader.selectors.userVerified(state)
    const thisWizard = Wizard.selectors.thisWizard({ state, router })

    return {
        ...props,
        history,
        loader: Loader.selectors.loader(state),
        publisherId: Loader.selectors.publisherId(state),
        getScopedLoader: (scope) => Loader.selectors.scopedLoader(state, scope),
        getTiersSorted: (scope) => Loader.selectors.tiersSorted(state, scope),
        getIsPledge: (scope) => Loader.selectors.isPledge(state, scope),
        getCheckoutPrice: Loader.selectors.getCheckoutPrice({ state, router }),
        wizardStore: state.wizard,
        scopedLoader,
        paymentMethods: isVerified ? paymentMethods(state) : [],
        updateLoader: Loader.creators.updateLoader,
        WizardRedux,
        WizardLoading,
        isSwitchingPlans: thisWizard?.submit?.payload?.currentPlanTierId,
        isUpdatingPaymentMethod: Loader.selectors.userHasCurrentPurchases(state),
    }
}

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({
        selectPaymentMethod: Payment.creators.selectPaymentMethod,
    }, dispatch),
    setDefaultPaymentMethod: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Payment.creators.setDefaultPaymentMethod,
        dispatch,
    }),
    addPaymentMethod: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Payment.creators.addPaymentMethod,
        dispatch,
    }),
    deletePaymentMethod: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Payment.creators.deletePaymentMethod,
        dispatch,
    }),
    onSelectPaymentMethodNoWizard: () => {
        xFrame.prompt.showThankYou({
            thankYouText: 'Your payment method has been successfully updated.',
            dispatch,
        })
    },
    dispatch,
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { dispatch } = dispatchProps

    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        onBackButtonClick: () => {
            if (stateProps.isSwitchingPlans || stateProps.isUpdatingPaymentMethod) {
                xFrame.prompt.showMenu({ dispatch })
            } else {
                stateProps.history.goBack()
            }
        },
    }
}

const InjectedSelectCard = withInjection(SelectCard, {
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
})

export default InjectedSelectCard
